export default __webpack_public_path__ + "static/media/portoplus-principal.c347b14c.png";